import type { RecordOrigin } from '@lio/api-types';
import { IssueStatus } from '@models/underwritingIssue';

// enums
export enum UnderwritingTab {
  Issues = 'Issues',
  NewIssue = 'NewIssue',
  UpdateIssue = 'UpdateIssue',
  Activity = 'Activity',
  NewActivity = 'NewActivity',
  UpdateActivity = 'UpdateActivity',
}

export enum MainUnderwritingTab {
  Issues = UnderwritingTab.Issues,
  Activity = UnderwritingTab.Activity,
}

// types
export type IssueType = {
  status: string;
  id: string;
  ruleId?: string;
  description: string | null;
  underwritingDescription?: string | null;
  reasoning: string | null;
  note?: string | null;
  quoteId?: string;
  author: {
    firstName?: string;
    lastName?: string;
  };
  createdAt: string | Date;
  resolvedAt?: string | Date;
  title?: string;
  origin?: RecordOrigin | null;
  resolvedOrigin?: RecordOrigin | null;
};

// interfaces
export interface IIssueCard {
  type: UnderwritingTab;
  title?: string;
  status: IssueStatus;
  ruleId?: string;
  id?: string;
  description: string;
  underwritingDescription?: string | null;
  reasoning?: string | null;
  note?: string | null;
  author?: string;
  date?: {
    createdAt: string;
    resolvedAt?: string;
  };
  onClick?: () => void;
  onDelete?: () => void;
  isPending?: boolean;
  origin?: RecordOrigin | null;
  resolvedOrigin?: RecordOrigin | null;
}

interface ITtitleTypes {
  [key: string]: string;
}

// key-value
export const tabs = [
  {
    key: UnderwritingTab.Issues,
    value: 0,
    label: 'Underwriting Issues',
    tabSearchParam: `underwriting-issues`,
  },
  {
    key: UnderwritingTab.Activity,
    value: 1,
    label: 'Underwriting Activity',
    tabSearchParam: `underwriting-activity`,
  },
];

export const titles = {
  [UnderwritingTab.Issues]: 'Underwriting',
  [UnderwritingTab.NewIssue]: 'Underwriting Issue',
  [UnderwritingTab.UpdateIssue]: 'Underwriting Issue',
  [UnderwritingTab.Activity]: 'Underwriting',
  [UnderwritingTab.NewActivity]: 'Add New Activity',
  [UnderwritingTab.UpdateActivity]: 'Update Activity',
};

export const underwritingIssuesLabels = {
  open: 'Open Underwriting Issues',
  closed: 'Closed Underwriting Issues',
  historical: 'Historical Underwriting Issues',
};

export const underwritingActivityLabels = {
  open: 'Open',
  closed: 'Closed',
  historical: 'Historical',
};

export const labelTypes = {
  [MainUnderwritingTab.Issues]: underwritingIssuesLabels,
  [MainUnderwritingTab.Activity]: underwritingActivityLabels,
};

export const addNewBtnText = {
  [MainUnderwritingTab.Issues]: 'Add New Issue',
  [MainUnderwritingTab.Activity]: 'Add New Activity',
};

export const underwritingIssuesTitles: ITtitleTypes = {
  accepted: 'Accepted Issue',
  open: 'Open Issue',
  rejected: 'Rejected Issue',
};

export const issueDetailsTitles = {
  [UnderwritingTab.NewIssue]: 'Issue Details',
  [UnderwritingTab.UpdateIssue]: 'Issue Details',
  [UnderwritingTab.NewActivity]: 'Details',
  [UnderwritingTab.UpdateActivity]: 'Details',
  [UnderwritingTab.Activity]: '',
  [UnderwritingTab.Issues]: '',
};

export const submitButtonText = {
  [UnderwritingTab.NewIssue]: 'Create',
  [UnderwritingTab.UpdateIssue]: 'Save',
  [UnderwritingTab.NewActivity]: 'Create',
  [UnderwritingTab.UpdateActivity]: 'Save',
  [UnderwritingTab.Activity]: '',
  [UnderwritingTab.Issues]: '',
};

export const newIssueSelectValues = [
  { label: 'Open', value: 'Open' as IssueStatus },
  { label: 'Accepted', value: 'Accepted' as IssueStatus },
  { label: 'Rejected', value: 'Rejected' as IssueStatus },
];
